<ion-header class="go-app-home">
  <go-app-title (newActivityOpened)="onNewActivityOpened()"></go-app-title>
</ion-header>

<ion-content class="go-app-home">
  <div class="flex-container full-height">
    <ng-container *ngIf="hasBaselineEnabled && !device.isMobileDevicePortrait">
      <go-app-navigation-menu #navMenu class="nav-menu"></go-app-navigation-menu>
    </ng-container>
    <ion-nav id="activities" #activities class="nav-content" [root]="rootPage" (ionNavDidChange)="onNavChange()"></ion-nav>
    <div class="no-data-message" *ngIf="!hasBaselineEnabled">
      {{'NO_ACCESS_TO_OMNIPRESENCE' | translate}}
    </div>
  </div>

  <div class="overlay"></div>
</ion-content>

<ion-footer class="go-app-home-footer" *ngIf="hasBaselineEnabled && device.isMobileDevicePortrait">
  <go-app-footer-navigation-menu #navFooterMenu></go-app-footer-navigation-menu>
</ion-footer>